import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { DateTimePicker } from 'react-widgets'
import { Button } from 'react-bootstrap'
import { Selector } from '@leverege/ui-elements'
import style from './style.css'

const classnames = require( 'classnames' )
const { LabelGroup, Flex } = require( '../../views' )
// const { HistoryActions, EventActions } = require( '../../actions' )
const util = require( './util' )
const { PathsModal } = require( './PathsModal' )
const { WhereModal } = require( './WhereModal' )

const PER_PAGE_VALUES = [
  { name : '1', value : 1 },
  { name : '5', value : 5 },
  { name : '10', value : 10 },
  { name : '50', value : 50 },
  { name : '100', value : 100 },
  { name : '500', value : 500 },
  { name : '1000', value : 1000 }
]

class AdvancedTimeEditor extends React.Component {

  static propTypes = {
    query : PropTypes.object.isRequired,
    queryName : PropTypes.string.isRequired,
    pagination : PropTypes.object.isRequired,
    onChange : PropTypes.func.isRequired,
    pathSuggestions : PropTypes.array,
    syncWithLocation : PropTypes.func,
    history : PropTypes.object.isRequired,
    location : PropTypes.object.isRequired,
    actions : PropTypes.object.isRequired
  };

  static defaultProps = {
    pathSuggestions : [],
    syncWithLocation : () => {}
  };

  static pathMap = {
    path : 0,
    alias : 1,
    func : 2,
    cast : 3
  }
  
  static TYPE = 'advancedTimeEditor';

  constructor( props, context ) {
    super( props, context )
    const { query } = this.props

    this.state = {
      newPath : '',
      newWhere : [ null, null, null ],
      pathsModalOpen : false,
      whereModalOpen : false
    }

    this.syncQueryToLocation( query )
  }

  syncQueryToLocation( query ) {
    const { syncWithLocation } = this.props
    syncWithLocation( query )
  }

  updateQuery( query ) {
    const { queryName, actions, dispatch } = this.props

    dispatch( actions.updateQuery( {
      name : queryName,
      query
    } ) )
    this.syncQueryToLocation( query )
  }

  onPerPage = ( value ) => {
    const { onChange, pagination } = this.props
    onChange( { path : 'pagination', value : { ...pagination, perPage : value } } )
  }

  onStart = ( start ) => {
    const { query } = this.props

    this.updateQuery( {
      ...query,
      start
    } )
  }

  jumpToNow = () => {
    const { onChange, pagination } = this.props
    onChange( { path : 'pagination', value : { ...pagination, startIndex : 0 } } )
    this.onEnd( Date.now() )
  }

  onEnd = ( end ) => {
    const { query } = this.props

    this.updateQuery( {
      ...query,
      end
    } )
  }

  onWhere = ( { index, item, action } ) => {
    const { query } = this.props

    if ( action === 'delete' ) {
      const where = [ ...( query.where || [] ) ]
      where.splice( index, 1 )

      this.updateQuery( {
        ...query,
        where
      } )
      return
    }

    if ( action === 'create' ) {
      this.onAddWhere()
      return
    }
    if ( action === 'createAnd' ) {
      this.onAddWhere( 'and' )
      return
    }
    if ( action === 'createOr' ) {
      this.onAddWhere( 'or' )
      return
    }

    if ( index === -1 ) {
      this.setState( { newWhere : item } )
    } else {
      const where = [ ...( query.where || [] ) ]
      where[index] = item

      this.updateQuery( {
        ...query,
        where
      } )
    }
  }

  onPath = ( { index, path, value, action } ) => {
    const { query } = this.props
    const { newPath } = this.state

    if ( action === 'delete' ) {
      const paths = [ ...( query.paths || [] ) ]
      paths.splice( index, 1 )

      this.updateQuery( {
        ...query,
        paths
      } )
      return
    }
    if ( action === 'create' ) {
      this.onAddPath()
      return
    }

    const i = AdvancedTimeEditor.pathMap[path]
    let toReplace 
    if ( index === -1 ) {
      toReplace = util.getPath( { path : i, value }, newPath )
      // console.log( util.getPath( { path : i, value }, newPath ) )
      this.setState( { newPath : toReplace } )
    } else {
      toReplace = util.getPath( { path : i, value }, query.paths[index] )
      const paths = [ ...( query.paths || [] ) ]
      paths[index] = toReplace

      this.updateQuery( {
        ...query,
        paths
      } )
    }
  }

  onAddPath = () => {
    const { query } = this.props
    const { newPath } = this.state

    const paths = [ ...( query.paths || [] ), newPath ]

    this.updateQuery( {
      ...query,
      paths
    } )

    this.setState( { newPath : '' } )
  }

  onAddWhere = ( wrapper ) => {
    const { query } = this.props
    const { newWhere } = this.state
    
    let wrapped = newWhere
    if ( wrapper ) {
      wrapped = [ wrapper, [ wrapped ] ]
    }
    
    const where = [ ...( query.where || [] ), wrapped ]

    this.updateQuery( {
      ...query,
      where
    } )
    this.setState( { newWhere : [ null, null, null ] } )
  }

  onEditPaths = () => {
    this.setState( { pathsModalOpen : true } )
  }

  onCloseEditPaths = () => {
    this.setState( { pathsModalOpen : false } )
  }

  onEditWhere = () => {
    this.setState( { whereModalOpen : true } )
  }

  onCloseEditWhere = () => {
    this.setState( { whereModalOpen : false } )
  }

  render() {
    const { query, pagination, className, pathSuggestions, location } = this.props
    const { newPath, newWhere, pathsModalOpen, whereModalOpen } = this.state

    return (
      <div className={classnames( style.filter, className, style.advanced )}>
        <Flex direction="column" className={style.advanceColumn}>
          <Flex direction="row" className={classnames( style.row, style.noSpace )}>
            <div className={classnames( style.row, style.left )}>
              <LabelGroup>
                <label>
                  History Data Points Per Page
                </label>
                <Selector
                  className={style.perPageDropdown}
                  values={PER_PAGE_VALUES}
                  value={pagination.perPage}
                  onChange={this.onPerPage} />
              </LabelGroup>
            </div>
            <div className={classnames( style.row, style.right )}>
              <LabelGroup>
                <label>Start</label>
                <DateTimePicker
                  onChange={this.onStart}
                  format="YYYY-MM-DDTHH:mm"
                  value={query.start ? new Date( query.start ) : null} />
              </LabelGroup>
              <div className={style.endContainer}>
                <LabelGroup>
                  <label>End</label>
                  <DateTimePicker
                    onChange={this.onEnd}
                    format="YYYY-MM-DDTHH:mm"
                    value={query.end ? new Date( query.end ) : null} />
                </LabelGroup>
                <div onClick={this.jumpToNow} className={style.jump}>Jump to now</div>
              </div>
            </div>
          </Flex>
          <div className={classnames( style.row, style.editGroup )}>
            <Button onClick={this.onEditPaths}>
              Edit Paths
            </Button>
            <Button onClick={this.onEditWhere}>
              Edit Where Clause
            </Button>
          </div>
        </Flex>
        <PathsModal newPath={newPath} close={this.onCloseEditPaths} isOpen={pathsModalOpen} pathSuggestions={pathSuggestions} paths={query.paths} onPath={this.onPath} />
        <WhereModal newWhere={newWhere} close={this.onCloseEditWhere} isOpen={whereModalOpen} whereSuggestions={pathSuggestions} where={query.where} onWhere={this.onWhere} />
      </div>
    )
  }
}
export default connect( state => ( { } ) )( AdvancedTimeEditor )
